import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { NativeCallService } from '../services/native-call.service';

const NATIVE_IOS_ALLOWED_ROUTES = [
  '/assignments',
  '/assignment',
  '/call',
  '/results_conversational',
  '/results_guided',
  '/results_visual_aid',
  '/result_personalized_practice',
  '/learning-pathway',
  '/assessment-pre-call',
  '/assessment-call',
];

export const nativeIosGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const nativeCallService = inject(NativeCallService);
  const router = inject(Router);

  if (!nativeCallService.isNativeIos) {
    return true;
  }

  const isAllowed = NATIVE_IOS_ALLOWED_ROUTES.some(
    (allowed) => state.url === allowed || state.url.startsWith(allowed + '?') || state.url.startsWith(allowed + '/')
  );

  return isAllowed ? true : router.parseUrl('/assignments');
};
